import React from "react";
import { useField } from "formik";

const MyCheckbox = ({ children, ...props }) => {
    const [field, meta] = useField({...props, type: 'checkbox'});
    // API-Werte kommen als String ("false", "0") — String "false" wäre sonst truthy
    const val = field.checked;
    const isChecked = val !== 'false' && val !== '0' && val !== false && val !== 0 && !!val;
    return (
        <>
            <label className="checkbox-input">
                <input type="checkbox" {...field} {...props} checked={isChecked} />
                {children}
            </label>
            {meta.touched && meta.error ? (
                <div className="error">{meta.error}</div>
            ) : null}
        </>
    );
};

export {MyCheckbox};